export enum AiAgentInteractionRole {
  Assistant = "assistant",
  User = "user",
  Developer = "developer",
}

export interface AiAgentInteraction {
  id: string;
  content: string;
  role: AiAgentInteractionRole;
  feedback?: boolean;
  isError?: boolean;
  processedAt?: string;
  avatarUrl?: string;
}

export interface AiAgentHistory {
  chat: AiAgentChat;
  messages: AiAgentMessage[];
  usage: number;
  cost?: string;
}

export interface AiAgentChat {
  id: string;
  companyCode: string;
  title: string;
  active: boolean;
  contactId?: string;
  createdAt: string;
  updatedAt: string;
  userId?: number;
  type: number;
}

export interface AiAgentMessage {
  id: string;
  chatId: string;
  role: string;
  content: string;
  feedback?: boolean;
  model?: string;
  promptTokens?: number;
  completionTokens?: number;
  cost?: string;
  processedAt?: string;
  note?: AiAgentChatMessageNote;
  avatarUrl?: string;
}

export interface AiAgentConversation {
  id: string;
  createdAt: string;
  messages: Array<{
    id: string;
    role: AiAgentInteractionRole;
    content: string;
    feedback?: boolean;
    processedAt?: string;
    avatarUrl?: string;
  }>;
  usage: number;
  type: number;
}

export interface AiAgentAuthorizedContact {
  id: string;
  companyCode: string;
  userId: number;
  name: string;
  phone: string;
  active: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
  tokens: number;
}

export interface AiAgentChartData {
  key: string;
  contact: string;
  tokens: number;
  date: string;
}

export interface AiAgentAdminMainChartData {
  key: number;
  companyName: string;
  date: string;
  promptTokens: number;
  completionTokens: number;
  totalTokens: number;
}

export interface AiAgentAdminMetrics {
  totalTokens: number;
  totalCompanies: number;
  totalCost: number;
  totalTools: number;
}

export interface AiAgentAdminFirstChartData {
  key: number;
  companyCode: string;
  companyName: string;
  date: string;
  promptTokens: number;
  completionTokens: number;
  totalTokens: number;
}

export interface AiAgentAdminSecondChartData {
  key: number;
  companyCode: string;
  companyName: string;
  promptTokens: number;
  completionTokens: number;
  totalTokens: number;
}

export interface AiAgentAdminThirdChartData {
  key: number;
  dateHour: string;
  tokens: number;
}

export interface AiAgentConversationDetails {
  id: string;
  chatId: string;
  index: number;
  role: string;
  content?: string;
  toolCallId?: string;
  functionName?: string;
  arguments?: string;
  feedback?: boolean;
  model?: string;
  processedAt?: string;
  avatarUrl?: string;
  promptTokens?: number;
  completionTokens?: number;
  cost?: string;
  createdAt: string;
  note?: AiAgentChatMessageNote;
}

export interface AiAgentCompanyPrompt {
  id: string;
  companyCode: string;
  content: string;
  active: boolean;
  createdAt: string;
}

export interface AiAgentRecommendedPromptCategory {
  id: number;
  description: string;
  createdAt: string;
}

export interface AiAgentRecommendedPrompt {
  title: string;
  categoryId: number;
  content: string;
  active: boolean;
  icon: string | null;
}

export type AiAgentRecommendedPromptPayload = AiAgentRecommendedPrompt & {
  id: string;
  createdAt: string;
  updatedAt: string;
};

export interface AiAgentSavedPrompt {
  id: string;
  title?: string;
  content: string;
  category?: string;
}

export interface AiAgentFreeRecommendedPrompt {
  id: string;
  title: string;
  content: string;
  suggestionGroup: number;
  icon: string;
}

export interface AiAgentFreeRecommendedPrompts {
  prompts: AiAgentFreeRecommendedPrompt[];
}

export interface AIAgentCompanyWithPromptBankAccess {
  companyCode: string;
  name: string;
  email: string;
}

export interface AiAgentAdminCustomer {
  companyCode: string;
  name: string;
}

export enum AiAgentChatMessageNoteCategory {
  HELPFULL = 1,
  HONEST = 2,
  HARMLESS = 3,
}

export interface AiAgentChatMessageNote {
  id: number;
  messageId: string;
  category: AiAgentChatMessageNoteCategory;
  content: string;
  createdBy: number;
  createdAt: string;
}

export interface AiKnowledgeBaseUpdate {
  success: boolean;
  message: string;
}
export interface AiKnowledgeBaseSearch {
  response: string;
  fonts: string[];
}

export interface LiveChatFile {
  id: string;
  name: string;
}
